// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep :not(.v-icon_18Ovw){font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.nsAddressForm_2BANt .flexContainer_egE_4{display:flex;align-content:space-between}.nsAddressForm_2BANt .flexContainer_egE_4 .firstCol_2ze9b{margin-right:20px}.nsAddressForm_2BANt .flexContainer_egE_4 .region_oF28G{width:70px}.optional_3yLlO{color:#bbbcbc}", ""]);
// Exports
exports.locals = {
	"v-icon": "v-icon_18Ovw",
	"nsAddressForm": "nsAddressForm_2BANt",
	"flexContainer": "flexContainer_egE_4",
	"firstCol": "firstCol_2ze9b",
	"region": "region_oF28G",
	"optional": "optional_3yLlO"
};
module.exports = exports;
